import restService from "../rest-service/RestService";
import { IDiagnosticEventModel, IWaterLossEventModel } from "../history-data-service/Models";

const EventsDataService = {
    saveDiagnosticEvent: async function (
        groupID: number,
        diagnosticEvent: IDiagnosticEventModel
    ): Promise<IDiagnosticEventModel> {
        const path: string = `events/diagnostic?contextGroupID=${groupID}`;

        const result = await restService.post<IDiagnosticEventModel, IDiagnosticEventModel>(path, diagnosticEvent);

        return result.data;
    },

    saveWaterLossEvent: async function (
        groupID: number,
        waterLossEvent: IWaterLossEventModel
    ): Promise<IWaterLossEventModel> {
        const path: string = `events/waterLoss?contextGroupID=${groupID}`;

        const result = await restService.post<IWaterLossEventModel, IWaterLossEventModel>(path, waterLossEvent);

        return result.data;
    }
}

export default EventsDataService;